/** @format */
import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { OtmId, Plan } from 'common-typescript/types';
import { Observable, shareReplay } from 'rxjs';
import { AppErrorHandler } from 'sis-components';
import { PlanLoaderService } from '../../common/service/plan-loader.service';
import { SelectedPlanService } from '../service/selected-plan.service';

@Component({
    selector: 'app-timing-plan-select',
    standalone: false,
    templateUrl: './timing-plan-select.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimingPlanSelectComponent {
    /**
     * Emits plans of the authenticated user,
     * including up-to-date data after updates.
     */
    protected readonly plans$: Observable<readonly Plan[]>;

    /**
     * Emits the selected plan from {@link plans$} that is currently selected,
     * or null if no plan is selected.
     */
    protected readonly selectedPlan$: Observable<Plan | null>;

    constructor(
        planLoaderService: PlanLoaderService,
        private readonly _selectedPlanService: SelectedPlanService,
        appErrorHandler: AppErrorHandler,
    ) {
        this.plans$ = planLoaderService.allPlans$.pipe(
            appErrorHandler.defaultErrorHandler(),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
        this.selectedPlan$ = _selectedPlanService.selectedPlan$.pipe(
            appErrorHandler.defaultErrorHandler(),
            shareReplay({ bufferSize: 1, refCount: true }),
        );
    }

    /**
     * Selects a new plan from among {@link plans$}.
     */
    protected selectPlan(planId: OtmId): void {
        this._selectedPlanService.setSelectedPlanId(planId);
    }
}
